import { useState } from 'react';
import { uploadFile } from '../services/global/global';
import { toast } from '../components/AppToast';

export const useFileUpload = (options = {}) => {
    const [showUploadModal, setShowUploadModal] = useState(false);
    const { 
        onSuccess, 
        onValidationError, 
        uploadPath,
        sampleFileUrl,
        sampleFileName // Add dynamic sample file name
    } = options;

    const openUploadModal = () => {
        setShowUploadModal(true);
    };

    const closeUploadModal = () => {
        setShowUploadModal(false);
    };

    const handleFileUpload = async (file) => {
        try {
            const result = await uploadFile(uploadPath, file);
            toast.success(result.message || 'File uploaded successfully');
            
            if (onSuccess) {
                onSuccess(result);
            }
            
            return result;
        } catch (error) {
            if (error.isValidationError && error.validationData) {
                if (onValidationError) {
                    onValidationError(error.validationData);
                }
            } else {
                toast.error(error || 'File upload failed');
            }
            throw error;
        }
    };

    const handleDownloadSample = () => {
        // Generate dynamic sample file name based on uploadPath if not provided
        const dynamicSampleFileName = sampleFileName || `${uploadPath}_sample.csv`;
        const dynamicSampleUrl = sampleFileUrl || `/samples/${dynamicSampleFileName}`;
        
        try {
            // Create a temporary link to download the sample file
            const link = document.createElement('a');
            link.href = dynamicSampleUrl;
            link.download = dynamicSampleFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            toast.success(`Downloading ${dynamicSampleFileName}...`);
        } catch (error) {
            console.error('Download error:', error);
            toast.error('Sample file download failed. Please check if the file exists.');
        }
    };

    return {
        showUploadModal,
        openUploadModal,
        closeUploadModal,
        handleFileUpload,
        handleDownloadSample,
        // Return computed values for use in components
        computedSampleFileName: sampleFileName || `${uploadPath}_sample.csv`,
        computedSampleUrl: sampleFileUrl || `/samples/${sampleFileName || `${uploadPath}_sample.csv`}`
    };
};
